import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { signInWithGoogle, logout, auth } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import './SignIn.css';

const SignIn = ({ user, onUserChange }) => {
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log('SignIn component mounted');
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      console.log('Auth state changed:', currentUser);
      if (currentUser) {
        console.log('User is signed in:', currentUser);
        onUserChange(currentUser);
      } else {
        console.log('No user is signed in');
        onUserChange(null);
      }
    });

    return () => unsubscribe();
  }, [onUserChange]);

  const handleSignIn = async () => {
    try {
      setError(null);
      console.log('Initiating sign-in process...');
      const user = await signInWithGoogle();
      console.log('Sign-in successful:', user);
      onUserChange(user);
    } catch (error) {
      console.error('Error signing in:', error);
      setError('Failed to sign in. Please try again.');
    }
  };

  const handleSignOut = async () => {
    try {
      console.log('Attempting to sign out...');
      await logout();
      console.log('Sign out successful');
      onUserChange(null);
    } catch (error) {
      console.error('Error signing out:', error);
      setError('Failed to sign out.');
    }
  };

  console.log('Current user state in SignIn component:', user);

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  if (user) {
    return (
      <div className="user-info">
        <img src={user.photoURL} alt="User" className="user-avatar" />
        <span className="user-name">{user.displayName}</span>
        <button className="sign-out-button" onClick={handleSignOut}>Sign Out</button>
      </div>
    );
  } else {
    return (
      <button className="sign-in-button" onClick={handleSignIn}>Sign In with Google</button>
    );
  }
};

SignIn.propTypes = {
  user: PropTypes.object,
  onUserChange: PropTypes.func.isRequired,
};

export default SignIn;